import { render } from "./YearShowList.vue?vue&type=template&id=757e2695"
import script from "./YearShowList.vue?vue&type=script&lang=ts"
export * from "./YearShowList.vue?vue&type=script&lang=ts"
script.render = render

export default script